var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9 19V13C9 12.4477 8.55228 12 8 12H4C3.44772 12 3 12.4477 3 13V19C3 19.5523 3.44772 20 4 20M9 19C9 19.5523 8.55228 20 8 20H4M9 19C9 19.5523 9.44772 20 10 20H14C14.5523 20 15 19.5523 15 19M9 19V9C9 8.44772 9.44772 8 10 8H14C14.5523 8 15 8.44772 15 9V19M4 20H18M15 19C15 19.5523 15.4477 20 16 20H20C20.5523 20 21 19.5523 21 19V5C21 4.44772 20.5523 4 20 4H16C15.4477 4 15 4.44772 15 5V19Z", stroke: "#222429", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});